export default {
  title:       'Gestão dos meus dados',
  description: 'Acesso aos dados',
};
